import React, { useState } from 'react';
import './header.css';
import { Link } from 'react-router-dom';
import headerImage from '../images/header_image.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTwitter, faYoutube, faLine } from '@fortawesome/free-brands-svg-icons';
import { isMobile } from 'react-device-detect'; // デバイスタイプの検出
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

const HeaderPC = () => {
  const [isHovered, setIsHovered] = useState(null);

  const handleMouseEnter = (index) => {
    setIsHovered(index);
  };

  const handleMouseLeave = () => {
    setIsHovered(null);
  };

  const menuItems = [
    { name: 'TOP', link: '/', subMenu: [] },
    { name: 'DETAIL', link: '/detail', subMenu: [] },
    { name: 'SCHEDULE', link: '/schedule', subMenu: [] },
    { name: 'APPLY', link: '/apply', subMenu: [] },
  ];

  return (
    <header
      className="App-header"
      style={{
        position: 'fixed',
        top: 0,
        width: '100%',
        height: '15vh',
        minHeight: '110px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: '10px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
      }}
    >
      <a href="/">
        <img
          src={headerImage}
          alt="関西マンドリンのロゴ"
          className="h-auto w-1/1 max-w-full mx-10"
          style={{
            maxHeight: '100%',
            minWidth: '150px',
            minHeight: '50px',
          }}
        />
      </a>

      <nav className="nav" style={{ marginLeft: 'auto' }}>
        <ul style={{ listStyle: 'none', padding: 0, marginRight: '100px', display: 'flex', alignItems: 'center' }}>
          {menuItems.map((item, index) => (
            <li
              key={index}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
              style={{ marginRight: '15px', fontSize: '18px', position: 'relative' }}
            >
              <Link to={item.link} style={{ textDecoration: 'none', color: '#333', fontWeight: 'bold' }}>
                {item.name}
              </Link>
              {isHovered === index && item.subMenu.length > 0 && (
                <ul className="sub-menu">
                  {item.subMenu.map((subItem, subIndex) => (
                    <li key={subIndex} style={{ margin: '10px 0' }}>
                      <Link to={subItem.link} style={{ textDecoration: 'none', color: '#333' }}>{subItem.name}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
        <br />
        <div className="social-icons" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
          <a href="https://www.instagram.com/anoen2025/?utm_source=ig_embed&ig_rid=e42f20b4-19c3-432a-93bd-d224e592bd6b" target="_blank" rel="noopener noreferrer" style={{ color: '#333', marginLeft: '30px', fontSize: '15px' }}>
            <FontAwesomeIcon icon={faInstagram} size="lg" />
          </a>
          <a href="https://x.com/anoen2025?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3Aanoen2025%7Ctwcon%5Es1" target="_blank" rel="noopener noreferrer" style={{ color: '#333', marginLeft: '30px', fontSize: '15px' }}>
            <FontAwesomeIcon icon={faTwitter} size="lg" />
          </a>
          <a href="https://www.youtube.com/@%E3%81%82%E3%81%AE%E6%BC%94" target="_blank" rel="noopener noreferrer" style={{ color: '#333', marginLeft: '30px', fontSize: '15px' }}>
            <FontAwesomeIcon icon={faYoutube} size="lg" />
          </a>
          {/* <a href="https://line.me" target="_blank" rel="noopener noreferrer" style={{ color: '#333', marginLeft: '30px', marginRight: '120px',fontSize: '15px' }}>
            <FontAwesomeIcon icon={faLine} size="lg" />
          </a> */}
        </div>
      </nav>
    </header>
  );
}


const HeaderMobile = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header
      className="App-header"
      style={{
        position: 'fixed',
        top: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: '5px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
      }}
    >
      <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <a href="/">
      <img
        src={headerImage}
        alt="Logo"
        className="h-auto max-w-[250px] mx-12" // 画像のサイズを80pxに調整
      />
        </a>
        <button
          onClick={toggleMenu}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '30px',
            marginRight: '20px',
            cursor: 'pointer',
          }}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>

      <nav
        className={`nav-menu ${isMenuOpen ? 'open' : ''}`}
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: '70%',
          height: '100%',
          backgroundColor: 'white',
          zIndex: 2000,
          transform: isMenuOpen ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.3s ease-in-out',
          paddingTop: '5px', // Added padding to accommodate the close button
        }}
      >
        <button
          onClick={toggleMenu}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '50px',
            position: 'absolute',
            top: '10px',
            right: '20px',
            cursor: 'pointer',
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <ul
          style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '5px',
          }}
        >
          <li style={{ marginBottom: '15px' }}>
            <Link to="/" style={{ textDecoration: 'none', color: '#333', fontWeight: 'bold', fontSize: '25px' }}>TOP PAGE</Link>
          </li>
          <li style={{ marginBottom: '15px' }}>
            <Link to="/detail" style={{ textDecoration: 'none', color: '#333', fontWeight: 'bold', fontSize: '25px' }}>DETAIL</Link>
          </li>
          <li style={{ marginBottom: '15px' }}>
            <Link to="/schedule" style={{ textDecoration: 'none', color: '#333', fontWeight: 'bold', fontSize: '25px' }}>SCHEDULE</Link>
          </li>
          <li style={{ marginBottom: '15px' }}>
            <Link to="/apply" style={{ textDecoration: 'none', color: '#333', fontWeight: 'bold', fontSize: '25px' }}>参加申込み</Link>
          </li>
        </ul>
        <div className="social-icons" style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: '40px' }}>
          <a href="https://www.instagram.com/anoen2025/?utm_source=ig_embed&ig_rid=e42f20b4-19c3-432a-93bd-d224e592bd6b" target="_blank" rel="noopener noreferrer" style={{ color: '#333', marginLeft: '0px' }}>
            <FontAwesomeIcon icon={faInstagram} size="lg" />
          </a>
          <a href="https://x.com/anoen2025?ref_src=twsrc%5Etfw%7Ctwcamp%5Eembeddedtimeline%7Ctwterm%5Escreen-name%3Aanoen2025%7Ctwcon%5Es1" target="_blank" rel="noopener noreferrer" style={{ color: '#333', marginLeft: '20px' }}>
            <FontAwesomeIcon icon={faTwitter} size="lg" />
          </a>
          <a href="https://www.youtube.com/channel/UC7PdyE_iablT2j_B5QrNVmg" target="_blank" rel="noopener noreferrer" style={{ color: '#333', marginLeft: '20px' }}>
            <FontAwesomeIcon icon={faYoutube} size="lg" />
          </a>
          {/* <a href="https://line.me" target="_blank" rel="noopener noreferrer" style={{ color: '#333', marginLeft: '20px' }}>
            <FontAwesomeIcon icon={faLine} size="lg" />
          </a> */}
        </div>
      </nav>
    </header>
  );
}

function Header() {
  return isMobile ? <HeaderMobile /> : <HeaderPC />;
}

export default Header;
